import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: theme.spacing(2),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    minHeight: "700px",
    padding: theme.spacing(10),
    width: `calc(100% - 700px)`,
    gap: "8px",
    margin: 0,
    boxShadow: `rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, 
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, 
      rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset`,
    borderRadius: "10px",

    [theme.breakpoints.up("lg")]: {
      width: `calc(100% - 400px)`,
    },

    [theme.breakpoints.down("md")]: {
      width:"auto",
      padding:'0px'
    },
  
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },

  listItem: {
    padding: theme.spacing(1.5, 0),
    "& h3": {
      cursor: "pointer",
      marginBottom: "20px",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  logo: {
    width: 48,
    height: 48,
  },
  settingsList: {
    padding: 0,
  },

  backIcon: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },

  communityHeading: {
    paddingTop: 0,
    fontFamily:"MontserratRegular",
    fontWeight: 700,
    fontSize: "20px",
    Lineheight: "23.03px",
    color: "#000000",
  },
  textHeading: {
    fontSize: "18px",
    color: "#2158D0",
    fontWeight: 700,
    fontFamily: "Inter",
  },
  pagetitle: {
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
    "& h5": {
      fontSize: "30px",
      fontWeight: 700,
      color: "#2158D0",
      fontFamily: "MontserratRegular",
    },
  },
  profileInfo: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
    margin: "auto",
    minWidth: 400,
    [theme.breakpoints.down("md")]: {
      minWidth:"unset"
    },
  },
  textField: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: "#F5F5F5",
    borderRadius: "10px",
  },
  inputStyle: {
    border: 0,
    backgroundColor: "white",
    color: "#F5F5F5",
  },
  formLabel: {
    color: "#2158D0",
    display: "block",
    textAlign: "left",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28.79px",
    fontFamily: "MontserratRegular",
    marginTop: "0px",
    marginBottom: "-8px",
  },
  checkBoxWrapper: {
    "& .MuiFormControlLabel-label": {
      fontSize: "14px",
      color: "#2158D0",
      fontWeight: 700,
      fontFamily: "MontserratRegular",
    },
  },
  paragraphText: {
    display: "block",
    textAlign: "center",
    color: "#000000",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "28.79px",
    fontFamily: "MontserratRegular",
  },
  singupLink: {
    color: "#2158D0",
    cursor: "pointer",
    textDecoration: "none",
  },
  submitBtn: {
    background: "#5C91FF",
    color: "#FFFFFF",
    textTransform: "capitalize",
    borderRadius: 6,
    padding: "11px 11px",
    marginBottom: theme.spacing(2),
    "&:hover": {
      background: "#5C91FF",
    },
    fontWeight: 700,
    fontSize: "20px",
  },
  profileContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  avatarContainer: {
    position: "relative", // Important for absolute positioning of camera icon
    width: 100,
    height: 100,
    "& .MuiAvatar-root.MuiAvatar-circle": {
      color: "white",
      width: "100%",
      height: "100%",
    },


  },
  cameraIcon: {
    width: 40,
    height: 40,
    backgroundColor: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: 0, 
    right: 0, 
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
  },
  logoWrapper:{
    "& img":{
      width:'180px',
      [theme.breakpoints.down("md")]: {
        width: "180px", 
      },
  
      [theme.breakpoints.down("sm")]: {
        width: "120px", 
      },
  
      [theme.breakpoints.down("xs")]: {
        width: "100px", 
      },

    }
  }

}));
